module.exports = __webpack_public_path__ + "fonts/Raleway-MediumItalic.a55ff2cd.ttf";